import useSeo from "@/hooks/useSeo";
import Hero from "@/pages/home/components/Hero";
import CategoryNav from "@/pages/home/components/CategoryNav";
import HotGrid from "@/pages/home/components/HotGrid";
import LatestRanking from "@/pages/home/components/LatestRanking";
import SubmitBanner from "@/pages/home/components/SubmitBanner";

export default function Home() {
  useSeo({
    title: "爆瓜爆料社 | 全网热门爆料汇总·每日更新精选",
    description:
      "爆瓜爆料社每日更新全网热门爆料，汇总明星八卦、网红黑料、社会热点与影视综艺，精选整理一站看全，做你每天的吃瓜情报站。",
    keywords: "爆瓜爆料,明星八卦,网红黑料,社会热点,爆料汇总",
    canonical: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "爆瓜爆料社",
        url: "https://zybdt.cn",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://zybdt.cn/category/star?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "爆瓜爆料社",
        url: "https://zybdt.cn",
        email: "tip@baogua-portal.example.com",
        description: "汇总全网热门爆料的内容聚合门户，涵盖明星八卦、网红黑料、社会热点与影视综艺。",
      },
    ],
  });

  return (
    <>
      <Hero />
      <CategoryNav />
      <HotGrid />
      <LatestRanking />
      <SubmitBanner />
    </>
  );
}